import quickSearchQuery from '~layers/app/graphql/quickSearch.gql'
import type { EsProduct } from '~layers/app/types/elastic'

export function useQuickSearch() {
  const search = useState('search', () => '')
  const searchDialogOpen = useState('searchDialogOpen', () => false)

  // Request
  const recentSearches = useLocalStorage<string[]>('recentSearches', [], { initOnMounted: true })

  const variables = computed(() => ({
    search: search.value,
  }))
  const enabled = computed(() => search.value.length > 2)
  const { result: data, loading, error } = useQuery(quickSearchQuery, variables, {
    enabled,
    debounce: 500,
  })
  const { quickSearch: trackQuickSearch } = useDataLayer()

  const searchRedirect = () => {
    if (!search.value) {
      return
    }
    // console.log('Search redirect', search.value)
    const router = useRouter()

    const queryParams = new URLSearchParams({ q: search.value })
    const condition = ({ label }: {
      label: string
    }) => (label.toLowerCase() === search.value.toLowerCase())
      || (label.length <= search.value.length + 3 && label.toLowerCase().startsWith(search.value.toLowerCase()))
    const matchingCategory = categories.value.find(condition)
    const matchingPage = pages.value.find(condition)
    if (matchingCategory || matchingPage) {
      trackQuickSearch(
        'redirect',
        data.value,
        {
          url: '/' + (matchingCategory || matchingPage).url + '/?' + queryParams.toString(),
          type: matchingCategory ? 'category' : 'page',
          [matchingCategory ? 'category' : 'page']: (matchingCategory || matchingPage).url,
        },
      )
      router.push({ path: '/' + (matchingCategory || matchingPage).url + '/', query: { q: search.value } })
    }
    else {
      trackQuickSearch(
        'submit',
        data.value,
        { url: '/search/?' + queryParams.toString(), type: 'search-result' },
      )
      router.push({ path: '/search/', query: { q: search.value } })
    }
  }

  const products = computed<EsProduct[]>(() => data.value?.products.products)
  const categories = computed(() => data.value?.categories.urls || [])
  const pages = computed(() => data.value?.pages.urls || [])

  const totalProducts = computed(() => data.value?.products.totalCount || 0)

  const hasResults = computed(() => {
    return totalProducts.value > 0 || categories.value.length > 0 || pages.value.length > 0
  })

  watch(data, () => {
    if (totalProducts.value > 0) {
      const newRecentSearches = new Set([data.value?.products.search, ...recentSearches.value])
      recentSearches.value = Array.from(newRecentSearches).slice(0, 5)
    }
  })

  return {
    data,
    search,
    searchDialogOpen,
    recentSearches,

    error,
    loading,

    hasResults,
    categories,
    pages,
    products,
    totalProducts,

    searchRedirect,
  }
}
